import axios from 'axios';
import { dropDown, worktypesGrid, targetWorktypeTypes, worktypeGroups } from './interfaces'
import GetJsonData from './dataAccess'

const apiURL = process.env.REACT_APP_API_URL;

export interface postWorkType {
   worktypeGroupId: number,
   description: string
}

export const getWorktypes = async (): Promise<worktypesGrid[]> => {
   const data = await GetJsonData('Worktype');

   const worktypesGridData: worktypesGrid[] = (data as worktypesGrid[]).map((item: any) => ({
      worktypeId: item.worktypeId,
      group: item.group,
      worktype: item.worktype
   }));

   return worktypesGridData;
}

export const getWorktypeGroups = async (): Promise<worktypeGroups[]> => {
   const data = await GetJsonData('Worktype/Groups');

   const worktypesGridData: worktypeGroups[] = (data as worktypeGroups[]).map((item: any) => ({
      value: item.value,
      text: item.text,
   }));

   return worktypesGridData;
}

export const getTargetWorktype = async (worktypeId: number): Promise<targetWorktypeTypes> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/Worktype/${worktypeId}`, {
      headers: {
         'Content-Type': 'application/json',
         Authorization: 'Bearer ' + token,
      },
   });

   const data: targetWorktypeTypes = response.data;

   const targetJobData: targetWorktypeTypes = {
      worktypeId: data.worktypeId,
      description: data.description,
      worktypegroupId: data.worktypegroupId,
      group: data.group
   };

   return targetJobData;
};

export const getWorktypeDropdown = async (): Promise<dropDown[]> => {
   const data = await GetJsonData('Worktype/ForDropdown');

   const worktypeDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => {
      const numericValue = Number(item.value)
      console.log(`Converting worktype value: "${item.value}" (${typeof item.value}) -> ${numericValue} (${typeof numericValue})`)
      return {
         text: item.text || 'Unknown',
         value: isNaN(numericValue) ? 0 : numericValue
      }
   });

   console.log('Final worktypeDropdownData:', worktypeDropdownData)
   return worktypeDropdownData;
};

export const getWorktypesForJobsFilterDropdown = async (searchTerm: string): Promise<dropDown[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/Jobs/Worktype/ForFilterDropdown?filter=${encodeURIComponent(searchTerm)}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data = response.data;

   const worktypeDropdownData: dropDown[] = (data as dropDown[]).map((item: any) => ({
      text: item.text,
      value: item.value,
   }));

   return worktypeDropdownData;
};

export const submitWorktype = async (worktype: any) => {

   const token = localStorage.getItem('authToken');
   console.log(worktype);

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Worktype`,
      method: 'post',
      data: {
         description: worktype.description,
         worktypeGroupId: worktype.worktypeGroupId.value,
      },
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   })

   const data: postWorkType = response.data;
   return data;
};
export const addWorkTypeFormik = async (worktype: any) => {
   const token = localStorage.getItem('authToken');
   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios({
      url: `https://${apiURL}/Worktype`,
      method: 'post',
      data: worktype,
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   })

   const data: postWorkType = response.data;
   return data;
};
export const updateWorkTypeFormik = async (worktype: any, id: number) => {
   const token = localStorage.getItem('authToken');
   if (!token) {
      throw new Error('Authorization token not found');
   }

   const dataToUpdate = {
      workTypeId: id,
      description: worktype.description
   }

   const response = await axios({
      url: `https://${apiURL}/Worktype/${id}`,
      method: 'put',
      data: dataToUpdate,
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   })

   const data: postWorkType = response.data;
   return data;
};

export const deleteWorktype = async (worktypeId: number) => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.delete(`https://${apiURL}/Worktype/${worktypeId}`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

   const data: any = response.data;

   return data;
};